import loadable from '@loadable/component';

import { selectNriStatus } from 'selectors/user';
import { useAppSelector } from 'storeHooks';

const LazyNriStrip = loadable(
  () => import(/* webpackChunkName: "AsyncNriStrip" */ './nriStrip')
);

const NriStripWrapper = () => {
  const nriStatus = useAppSelector(selectNriStatus);

  if (!nriStatus) return null;

  return <LazyNriStrip />;
};

export default NriStripWrapper;
